import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './inspirecommila_pagina.module.scss';
import livro1 from './src/livro1.jpeg';
import livro2 from './src/livro2.jpeg';

const LIVRO_URL = 'https://pay.kiwify.com.br/LEGuFPG';

const Livro_inspirecommila: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.sheet}>
                <div className={styles.header}>
                    <Link to="/inspirecommila" className={styles.back} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1>Livro digital</h1>
                </div>

                <figure className={`${styles.hero} ${styles.wide}`}>
                    <img src={livro1} alt="Mila no lançamento do livro Mulheres que se amam" />
                </figure>

                <div className={styles.corpo}>
                    <p className={styles.eyebrow}>Mulheres que se amam</p>
                    <h2 className={styles.titulo}>A mudança começa de dentro</h2>
                    <p className={styles.lead}>
                        Um chamado para mulheres presas em ciclos de dependência emocional, insegurança e relações
                        disfuncionais.
                    </p>
                    <div className={styles.texto}>
                        <p>
                            Relatos sinceros e o método dos 6 Pilares da Autoestima como guia. As autoras compartilham
                            o impacto de se amar, e a convicção de que, se elas conseguiram, você também pode.
                        </p>
                    </div>
                    <p className={styles.citacao}>“Eu escolho me amar, eu escolho confiar em mim.”</p>
                    <div className={styles.galeria}>
                        <img src={livro1} alt="Autógrafos no lançamento" />
                        <img src={livro2} alt="Mila com o livro nas mãos" />
                    </div>
                    <a href={LIVRO_URL} target="_blank" rel="noopener noreferrer" className={styles.cta}>
                        Quero o livro
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Livro_inspirecommila;
